import { render, staticRenderFns } from "./AnimalSubscriptionsTable.vue?vue&type=template&id=64a75474&scoped=true&"
import script from "./AnimalSubscriptionsTable.vue?vue&type=script&lang=ts&"
export * from "./AnimalSubscriptionsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a75474",
  null
  
)

export default component.exports